import {
    setSmartPillBlockVisibility,
    setSmartPillFeedbackSubmitted,
} from '../actions/smartPillBlockActions';
import { mutator } from 'satcheljs';

export const smartPillBlockVisibilityMutator = mutator(
    setSmartPillBlockVisibility,
    actionMessage => {
        actionMessage.viewState.smartPillBlockVisible = actionMessage.smartPillBlockVisible;
    }
);

export const smartPillFeedbackSubmittedMutator = mutator(
    setSmartPillFeedbackSubmitted,
    actionMessage => {
        actionMessage.item.smartPillFeedbackSubmitted = actionMessage.smartPillFeedbackSubmitted;
    }
);

export { ClientItem } from 'owa-mail-store';
export { SmartPillViewState } from 'owa-mail-reading-pane-store';
